import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  baseurl = environment.API_BASE_URL;
  secretKey = "(!@#Passcode!@#)";
  menus = [
    {
      previlageId:'dsbard',
      icon: 'icon-dashboard',
      name: 'Dashboard',
      link: '/core/report/dashboard',
      active: false,
      isChild: false,
      routeOrigin: 'dashboard'
    },
    {
      previlageId: 'mgnogn',
      icon: 'icon-organization',
      name: 'Organisation',
      link: '/core/org/home',
      active: false,
      isChild: false,
      routeOrigin: 'org'
    },
    {
      previlageId: 'euaMru',
      icon: 'icon-users',
      name: 'User Management',
      link: '',
      active: false,
      isChild: true,
      showSubMenu: false,
      routeOrigin: 'user',
      subMenu: [
        {
          previlageId: 'euausr',
          icon: '',
          name: 'Manage Users',
          link: '/core/user/home',
          active: false,
          routeOrigin: 'user',
        },
        {
          previlageId: 'eualgs',
          icon: '',
          name: 'User Enrollment Logs',
          link: '/core/user/userLogs',
          active: false,
          routeOrigin: 'user',
        }
      ]
    },
    {
      previlageId: 'ctlmm1',
      icon: 'icon-catalogue',
      name: 'Catalogue',
      link: '/core/course/catalogue-card',
      active: false,
      isChild: false,
      routeOrigin: 'catalog'
    },
    {
      previlageId: 'crmnmt',
      icon: 'icon-bookmonitor',
      name: 'Course',
      link: '/core/course/managecourse',
      active: false,
      isChild: false,
      routeOrigin: 'course'
    },
    {
      previlageId: 'cpymgt',
      icon: 'icon-organization',
      name: 'Pathway',
      link: '/core/course/managepathway',
      active: false,
      isChild: false,
      routeOrigin: 'pathway'
    },
    {
      previlageId: 'eRprpe',
      icon: 'icon-analytics',
      name: 'Report',
      link: '',
      active: false,
      isChild: true,
      showSubMenu: false,
      routeOrigin: 'report',
      subMenu: [
        {
          previlageId: 'usrprt',
          icon: '',
          name: 'Course Completion Report',
          link: '/core/report/home',
          active: false,
          routeOrigin: 'report'
        },
        {
          previlageId: 'ogrprt',
          icon: '',
          name: 'User Performance Report',
          link: '/core/report/orgReport',
          active: false,
          routeOrigin: 'report'
        },
        {
          previlageId: 'exerpt',
          icon: '',
          name: 'Executive Report',
          link: '/core/report/executiveReport',
          active: false,
          routeOrigin: 'report'
        },
           {
          previlageId: 'exerpt',
          icon: '',
          name: 'LearnKonnect Order Report',
          link: '/core/report/order-report',
          active: false,
          routeOrigin: 'report'
        }
      ]
    },
    {
      previlageId: 'rlapms',
      icon: 'icon-Accountlock',
      name: 'Roles and Permissions',
      link: '/core/org/roles',
      active: false,
      isChild: false,
      routeOrigin: 'roles'
    },
    {
      previlageId: 'dsbard',
      icon: 'icon-image',
      name: 'Banners',
      link: '/core/report/banner',
      active: false,
      isChild: false,
      routeOrigin: 'banner'
    },
    {
      previlageId: 'asgpyw',
      icon: 'icon-catalog',
      name: 'Assign Pathway',
      link: '/core/course/assign-pathway',
      active: false,
      isChild: false,
      routeOrigin: 'assignpathway'
    },
  ];
  constructor(
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog) { }

  login(loginData) {
    return this.http.post(this.baseurl + 'userLogin', loginData);
  }
  getcaptchaConfig(CConfig) {
    return this.http.post(this.baseurl + 'getcaptchaConfig', CConfig)
  }
  fogetPasswordEmail(mailData) {
    return this.http.post(this.baseurl + 'userforgotPassword', mailData);
  }
  resetPassword(pwdData) {
    return this.http.post(this.baseurl + 'submitResetPassword', pwdData);
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.http.post(this.baseurl + 'logout', {});
    this.router.navigate(['/']);
    this.dialog.closeAll();
  }
  getcatalogue(data) {
    return this.http.post(this.baseurl + 'getcatalogue', data);
  }
  createcatalogue(data) {
    return this.http.post(this.baseurl + 'createcatalogue', data);
  }
  updateCatalogue(data) {
    return this.http.post(this.baseurl + 'updateCatalogue', data);
  }
  getdepartment(){
    return this.http.get(this.baseurl + 'getdepartment');
  }
  createCourse(data) {
    return this.http.post(this.baseurl + 'createCourse', data);
  }
  updateCourse(data) {
    return this.http.post(this.baseurl + 'updateCourse', data);
  }
  getOrganization(data) {
    return this.http.post(this.baseurl + 'getOrganization', data);
  }
  createOrganization(data) {
    return this.http.post(this.baseurl + 'createOrganization', data);
  }
  updateOrganization(data) {
    return this.http.post(this.baseurl + 'updateOrganization', data);
  }
  updateUsers(data) {
    return this.http.post(this.baseurl + 'updateUsers', data);
  }
  profileImgUpload(formData) {
    return this.http.post(this.baseurl + 'profileImgUpload', formData);
  }
  updatebanner(data) {
    return this.http.post(this.baseurl + 'updatebanner', data);
  }
  getbanner(params) {
    return this.http.get(this.baseurl + 'getbanner?orgId='+params.orgId);
  }
  deletebanner(data) {
    return this.http.post(this.baseurl + 'deletebanner', data);
  }
  getCourseMaster(param) {
    return this.http.post(this.baseurl + 'getCoursebyAdmin', param);
  }
  mapCourse(data) {
    return this.http.post(this.baseurl + 'MapCourse', data);
  }
  getOrgUsers(data) {
    return this.http.post(this.baseurl + 'getOrgUsers', data);
  }
  updatePassword(param) {
    return this.http.post(this.baseurl + 'updatePassword', param);
  }
  changepassword(param) {
    return this.http.post(this.baseurl + 'changepassword', param);
  }
  getOrgAdmin(data) {
    return this.http.post(this.baseurl + 'getOrgAdmin', data);
  }
  getcollegelist(data) {
    return this.http.post(this.baseurl + 'getcollegelist' , data);
  }
  getAccessPermsission(data) {
    return this.http.post(this.baseurl + 'getAccessPermsission', data);
  }
  getOrganizationReport(data) {
    return this.http.post(this.baseurl + 'organizationReport', data);
  }
  getOrgUserReport(data) {
    return this.http.post(this.baseurl + 'orgUserReport', data);
  }
  orgReportView(data) {
    return this.http.post(this.baseurl + 'orgReportView', data);
  }
  getuserReport(data) {
    return this.http.post(this.baseurl + 'userReport', data);
  }
  getuserReportView(data) {
    return this.http.post(this.baseurl + 'userReportView', data);
  }
  getcourseReportView(data) {
    return this.http.post(this.baseurl + 'courseReportView', data);
  }
  getcourseReport(data) {
    return this.http.post(this.baseurl + 'courseReport', data);
  }
  createRole(data) {
    return this.http.post(this.baseurl + 'createRole', data);
  }
  updateRole(data) {
    return this.http.post(this.baseurl + 'updateRole', data);
  }
  getRoles(data) {
    return this.http.post(this.baseurl + 'getRoles', data);
  }
  getRolesByUser(data) {
    return this.http.post(this.baseurl + 'getRolesByUser', data);
  }
  getCoursepercentage(data) {
    return this.http.post(this.baseurl + 'getCoursepercentage', data);
  }
  getuserAuthorization(data) {
    return this.http.post(this.baseurl + 'getuserAuthorization', data);
  }
  getDashboardCount(data) {
    return this.http.post(this.baseurl + 'getDashboardCount', data);
  }
  getStatics(data) {
    return this.http.post(this.baseurl + 'getStatics', data);
  }
  getUserLogs(data) {
    return this.http.post(this.baseurl + 'userLogs', data);
  }
  bulkUserWithCourse(data) {
    return this.http.post(this.baseurl + 'bulkUserWithCourse', data);
  }
  getAllUsers(data) {
    return this.http.post(this.baseurl + 'getAllUsers', data);
  }
  getOrganisation(data) {
    return this.http.post(this.baseurl + 'getOrganization', data);
  }
  getPathway(data){
    return this.http.post(this.baseurl + 'getPathway', data);
  }
  getCoursePathway(data){
    return this.http.post(this.baseurl + 'getCoursePathway', data);
  }
  getCourse(data){
    return this.http.post(this.baseurl + 'getCourse', data);
  }
  getPathWayMapping(data: any){
    return this.http.post(this.baseurl + 'getPathWayMapping', data);
  }
  subscribePathway(data: any){
    return this.http.post(this.baseurl + 'subscribe', data);
  }
  getPathWayDetails(data){
    return this.http.post(this.baseurl + 'getPathWayDetails', data);
  }
  editPathway(data){
    return this.http.post(this.baseurl + 'editPathway', data);
  }
  createPathway(data){
    return this.http.post(this.baseurl + 'createPathway', data);
  }
  export(header, key, data, fileName) {
    let ws = XLSX.utils.aoa_to_sheet([header]);
    XLSX.utils.sheet_add_json(ws, data, {
      header: key,
      skipHeader: true,
      origin: 1
    });
    let wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, fileName);
    XLSX.writeFile(wb, fileName + '.xlsx');
    this.toastr.success('Downloaded successfully');
  }
  exportToExcel(header, key, data, fileName, json) {
    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([json]);
    XLSX.utils.sheet_add_aoa(ws, [header], { origin: 'A5' });
    XLSX.utils.sheet_add_json(ws, data, { origin: 'A6', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, fileName);
    XLSX.writeFile(wb, fileName + '.xlsx');
    this.toastr.success('Downloaded successfully');
  }

  getRecords(data) {
    return this.http.post(this.baseurl + 'getRecords', data);
  }
  getOrgCourseReport(data) {
    return this.http.post(this.baseurl + 'getOrgCourseReport', data);
  }
  getCourseByUserReport(data) {
    return this.http.post(this.baseurl + 'getCourseByUserReport', data);
  }
  getOrgTrackRecords(data) {
    return this.http.post(this.baseurl + 'getOrgTrackRecords', data);
  }
  getPathwayMyLearning(data) {
    return this.http.post(this.baseurl + 'getPathwayMyLearning', data)
  }
  getMyLeaningCoursePathway(data) {
    return this.http.post(this.baseurl + 'getMyLeaningCoursePathway', data)
  }
  getUserCertificate(data) {
    return this.http.post(this.baseurl + 'getUserCertificate', data);
  }
  getRolesType() {
    return this.http.get(this.baseurl + 'getRolesType');
  }
  getOrgDashboard(data) {
    return this.http.post(this.baseurl + 'getOrgDashboard', data);
  }
  exportcareerpathway(paramsData: { orgId: string; collegeId?: string }) {
      return this.http.get(`${this.baseurl}exportcareerpathway`, {
      params: paramsData
    });
  }
  getStudentLeaderboard(paramsData: { orgId: string; collegeId?: string }) {
      return this.http.get(`${this.baseurl}student_leaderboard`, {
      params: paramsData
    });
  }
  getDashboardLeaderboard(paramsData: { orgId: string; collegeId?: string }) {
    return this.http.get(`${this.baseurl}department_leaderboard`, {
      params: paramsData
    });
  }
  getOrderAPI(chartID){
    return this.http.post(environment.orderAPIURL + "?id=" + chartID + "&tolerance=3600&sdk=2",{});
  }
  downloadAsCSV(data: any,filename:string) {

  const replacer = (key, value) => value === null ? '' : value;

  const header = Object.keys(data[0]);
  let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
  let quotedHeader = header.map(field => `"${field}"`);
  csv.unshift(quotedHeader.join(','));
  let csvArray = csv.join('\r\n');
  var blob = new Blob([csvArray], {type: 'text/csv' })
  saveAs(blob, filename + ".csv");
  // this.toastr.success('Downloaded Successfully');
}
}

